import {
  Home, Folder, Users, Star, Trash2,
  User, Calendar, Image, Plus,
} from 'lucide-react'
import { navSections, quickAccessItems } from '@/utils/data'
import styles from './Sidebar.module.css'

const ICON_MAP: Record<string, React.ElementType> = {
  Home, Folder, Users, Star, Trash2, User, Calendar, Image,
}

export function Sidebar() {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.createBtn}>
        <button className={styles.createButton}>
          <Plus size={16} />
          <span>Create or upload</span>
        </button>
      </div>

      {navSections.map((section) => (
        <div key={section.title} className={styles.section}>
          {section.title && (
            <div className={styles.sectionTitle}>{section.title}</div>
          )}
          <nav>
            {section.items.map((item) => {
              const Icon = ICON_MAP[item.icon]
              return (
                <button
                  key={item.id}
                  className={`${styles.navItem} ${item.active ? styles.active : ''}`}
                >
                  {Icon && <Icon size={16} />}
                  <span>{item.label}</span>
                </button>
              )
            })}
          </nav>
        </div>
      ))}

      <div className={styles.section}>
        <div className={styles.sectionTitle}>Quick access</div>
        {quickAccessItems.map((item) => (
          <button key={item.id} className={styles.navItem}>
            <span
              className={styles.quickIcon}
              style={{ backgroundColor: item.color }}
            >
              {item.initial}
            </span>
            <span className={styles.quickLabel}>{item.label}</span>
          </button>
        ))}
        <button className={styles.morePlaces}>More places...</button>
      </div>

      <div className={styles.storageSection}>
        <div className={styles.storageBar}>
          <div className={styles.storageBarFill} style={{ width: '6.5%' }} />
        </div>
        <span className={styles.storageText}>6.5 GB used of 1 TB</span>
        <button className={styles.storageLink}>Get more storage</button>
      </div>
    </aside>
  )
}
